<template>
    <div>     
        <v-row class="mt-2">
            <v-col cols="12" md="3" v-if="hasPermission(permissions.model.create)">
                <v-btn block color="primary" @click="handleAddModel">
                    <v-icon left>mdi-plus</v-icon>
                    {{$t('add_a_model')}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="models"
                    :loading="loading"
                    disable-pagination
                    hide-default-footer
                    disable-sort
                >
                    <template v-slot:[`item.name`]="{item}">
                        <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(permissions.model.read)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.name}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import permissions from '../../data/permissions'
import authorize from '../../utils/authorize'
export default {
    name: "ModelList",
    data() {
        return {
            headers: [
                { text: this.$t("name"), value: "name" },
            ],
            loading: false,
            permissions
        }
    },
    props: {
        models: Array,
        brand: Object
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        handleClickRow(model) {
            this.$router.push({ name: "ModelDisplay" , params: { modelID : model.id } })
        },
        handleAddModel() {
            this.$router.push({ name: "ModelCreate",  params: { brandID: this.brand.id}, query: { brandName: this.brand.name}})
        }
    }
}
</script>

<style>

</style>